import React from 'react';
import { Chip } from '@mui/material';

const STATUS_MAP = {
  draft:          { label: 'Draft',          color: 'default' },
  pending:        { label: 'Pending',         color: 'warning' },
  booked:         { label: 'Booked',          color: 'info' },
  submitted:      { label: 'Submitted',       color: 'info' },
  paid:           { label: 'Paid',            color: 'success' },
  cancelled:      { label: 'Cancelled',       color: 'error' },
  active:         { label: 'Active',          color: 'success' },
  partially_used: { label: 'Part. Used',      color: 'warning' },
  fully_used:     { label: 'Fully Used',      color: 'default' },
  expired:        { label: 'Expired',         color: 'error' },
  processing:     { label: 'Processing',      color: 'info' },
  completed:      { label: 'Completed',       color: 'success' },
  failed:         { label: 'Failed',          color: 'error' },
  knocked_off:    { label: 'Knocked Off',     color: 'success' },
  partial:        { label: 'Partial',         color: 'warning' },
  in_transit:     { label: 'In Transit',      color: 'info' },
  delivered:      { label: 'Delivered',       color: 'success' },
};

export default function StatusChip({ status, size = 'small' }) {
  const s = STATUS_MAP[status] || { label: status || '—', color: 'default' };
  return <Chip label={s.label} color={s.color} size={size} sx={{ fontWeight: 600, fontSize: 11 }} />;
}
